module.exports = __webpack_public_path__ + "1b6e818ed2ce599de103cc96ab36058e.png";